<script>
import { api } from "@/state/services";

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    client: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      paymentType: 'individual',
      balances: {
        individual: 0,
        juridica: 0,
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.modal;
      },
      set(value) {
        this.$emit("update:modal", value);
      },
    },
    insufficientBalance() {
      return this.balances[this.paymentType] < 1;
    },
  },
  methods: {
    onShow() {
      this.paymentType = 'individual';

      api.get('exclusaoindividual/clients/balances').then((response) => {
        if (response.data.status == "success") {
          this.balances.individual = response.data.individual;
          this.balances.juridica = response.data.juridica;
        }
      });
    },
    payClient() {
      this.loading = true;

      api
        .post('exclusaoindividual/clients/payment', {
          id: this.client.id,
          type: this.paymentType,
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success("O pagamento foi realizado com sucesso!");

            this.loading = false;
            this.show = false;

            this.$emit('paid');
          } else {
            this.$toast.error(response.data.message);
            this.loading = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.$toast.error("Erro ao realizar pagamento, tente novamente.");
            this.loading = false;
          }
        });
    },
  },
};
</script>

<template>
  <b-modal v-model="show" modal-class="modal-bottom" hide-footer hide-header @show="onShow">
    <div class="px-3">
      <h5 class="mb-4" v-if="client">Deseja realizar o pagamento do cliente <span class="bg-soft-dark px-2 rounded text-uppercase">{{ client.name }}</span>?</h5>

      <b-form-group class="mb-4">
        <b-form-radio v-model="paymentType" name="paymentType" value="individual" :disabled="balances.individual < 1">
          Exclusão Individual ({{ balances.individual }} crédito{{ balances.individual == 1 ? '' : 's' }})
        </b-form-radio>
        <b-form-radio v-model="paymentType" name="paymentType" value="juridica" :disabled="balances.juridica < 1">
          Exclusão Jurídica ({{ balances.juridica }} crédito{{ balances.juridica == 1 ? '' : 's' }})
        </b-form-radio>
      </b-form-group>

      <div class="mt-4 d-flex justify-content-between">
        <b-button class="btn-lg" variant="default" :disabled="loading || insufficientBalance" v-on:click="payClient()">
          Pagar
          <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
        <b-button class="text-dark text-decoration-none" variant="link" v-on:click="show = false">Fechar</b-button>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
